import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageSquare, Menu, X, LogIn } from "lucide-react";
import {
  BUSINESS_NAME,
  BUSINESS_SLOGAN,
  BUSINESS_EMAIL,
  BUSINESS_MOBILE,
  LOGO_URL,
  waLink,
} from "../lib/site";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Plain T-Shirts", to: "/premiumtshirtmanufacturing" },
  { label: "DTF Printing", to: "/dtf" },
  { label: "POD", to: "/POD" },
];

export const SiteHeader = ({ active }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Top Banner Contact Bar */}
      <div className="bg-slate-900 text-white text-xs md:text-sm py-2 px-4 border-b border-slate-800">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 font-mono">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <Phone className="w-3.5 h-3.5 text-[#25D366]" />
              <a href={`tel:${BUSINESS_MOBILE}`} className="hover:underline">+91 {BUSINESS_MOBILE}</a>
            </span>
            <span className="hidden sm:flex items-center gap-1.5">
              <Mail className="w-3.5 h-3.5 text-[#FFD400]" />
              <a href={`mailto:${BUSINESS_EMAIL}`} className="hover:underline">{BUSINESS_EMAIL}</a>
            </span>
          </div>
          <div className="flex items-center gap-2 uppercase tracking-wider text-[10px] bg-slate-800 px-2 py-0.5 rounded">
            <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse"></span>
            Super Fast Dispatch Across India
          </div>
        </div>
      </div>

      {/* Primary Navigation */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
            <img src={LOGO_URL} alt={BUSINESS_NAME} className="w-12 h-12 rounded-full border border-slate-900 object-cover" />
            <div className="flex flex-col">
              <span className="font-extrabold text-base sm:text-lg tracking-tight leading-none uppercase">{BUSINESS_NAME}</span>
              <span className="text-[10px] font-mono tracking-widest text-slate-500 uppercase mt-0.5">{BUSINESS_SLOGAN}</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-7 font-semibold text-sm tracking-wide uppercase">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`transition-colors ${active === l.to ? "text-slate-950 underline underline-offset-4" : "text-slate-600 hover:text-slate-950"}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/pod-portal"
              data-testid="header-brand-login"
              className="hidden sm:flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-slate-700 hover:text-slate-950 border-2 border-slate-950 px-4 py-2.5 transition-all"
            >
              <LogIn className="w-4 h-4" /> Brand Login
            </Link>
            <a
              href={waLink(`Hi ${BUSINESS_NAME}, I have an enquiry.`)}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-2 bg-[#25D366] text-white hover:bg-[#20bd5a] px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-all duration-150 border border-slate-950 shadow-[2px_2px_0px_0px_rgba(15,23,42,1)] hover:translate-y-[-1px]"
            >
              <MessageSquare className="w-4 h-4 fill-white text-[#25D366]" />
              WhatsApp
            </a>
            <button
              type="button"
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-toggle"
              className="md:hidden w-10 h-10 flex items-center justify-center border-2 border-slate-950"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-1" data-testid="mobile-menu">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={`block py-2.5 px-3 font-semibold text-sm uppercase tracking-wide ${active === l.to ? "bg-slate-950 text-white" : "text-slate-700 hover:bg-slate-100"}`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/pod-portal"
              onClick={() => setOpen(false)}
              className="block py-2.5 px-3 font-semibold text-sm uppercase tracking-wide text-slate-700 hover:bg-slate-100 border-t border-slate-200 mt-1 pt-3"
            >
              Brand Login
            </Link>
          </div>
        )}
      </header>
    </>
  );
};

export default SiteHeader;
